import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {Button, Overlay, Popover} from 'react-bootstrap'
import Icon from './Icon'
import style from './TagBar.less'

class TagBar extends Component {
    static propTypes = {
        display: PropTypes.func,
        identify: PropTypes.func,
        multi: PropTypes.bool,
        disabled: PropTypes.any,
        label: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            const {value, multi} = nextProps

            if (!multi && value) {
                this.setState({opened: false})
            }
        }
    }

    close() {
        this.setState({opened: false})
    }

    _remove(tag) {
        const {value, onChange, onSubmit, identify, multi} = this.props

        if (multi) {
            const arrayValue = value || []
            const tagId = identify(tag)
            const index = arrayValue.findIndex((value) => identify(value) == tagId)

            if (index >= 0) {
                if (onSubmit) {
                    onSubmit('Remove', tag)
                }

                if (onChange) {
                    var nextValue = [...arrayValue]
                    nextValue.splice(index, 1)
                    onChange(nextValue)
                }
            }
        } else {
            if ((value && identify(value)) == identify(tag)) {
                if (onSubmit) {
                    onSubmit('Remove', value)
                }

                if (onChange) {
                    onChange(null)
                }
            }
        }
    }

    _open(event) {
        event.preventDefault()
        this.setState({opened: true})
    }

    _close(event) {
        if (event) {
            event.preventDefault()
        }

        this.setState({opened: false})
    }

    render() {
        const {children, display, identify, multi, disabled, label, value, onChange, onSubmit, ...other} = this.props
        const {opened} = this.state
        const {bodyContainer, openIcon} = this.refs

        const buttonDisabled = (typeof disabled == 'function') && disabled || (() => disabled)

        return (
            <div className={style.default}>
                <ul
                    className={style.tagGroup}
                    ref='bodyContainer'>
                    {multi && value && value.map((tag, index) => (
                        <li
                            key={identify(tag)}>
                            <Button
                                bsStyle='link'
                                disabled={buttonDisabled(tag, index)}
                                onClick={() => this._remove(tag)}>
                                {display(tag, index, value)}
                            </Button>
                        </li>
                    ))}
                    {!multi && value && (
                        <li>
                            <Button
                                bsStyle='link'
                                disabled={buttonDisabled(value)}
                                onClick={() => this._remove(value)}>
                                {display(value)}
                            </Button>
                        </li>
                    )}
                    {(multi || !value) && (
                        <li>
                            <Button
                                bsStyle='link'
                                disabled={disabled == true}
                                onClick={(e) => this._open(e)}>
                                <Icon
                                    ref='openIcon'
                                    icon='plus'
                                    size='md' />
                                <label>{label}</label>
                            </Button>
                        </li>
                    )}
                </ul>
                {(multi || !value) && (
                    <Overlay rootClose
                        target={() => findDOMNode(openIcon)}
                        placement='bottom'
                        show={opened}
                        container={bodyContainer}
                        onHide={(e) => this._close(e)}>
                        <Popover
                            style={{width: '100%'}}>
                            {children}
                        </Popover>
                    </Overlay>
                )}
            </div>
        )
    }
}

export default TagBar


// WEBPACK FOOTER //
// ./lib/core/components/TagBar.js